import { render } from "./BySalesWizard.vue?vue&type=template&id=564edb0d"
import script from "./BySalesWizard.vue?vue&type=script&lang=js"
export * from "./BySalesWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__